<div class="confirm-modal ig-modal ai-event-classification-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">AI Event Classification Assistant</div>

    <div>
        <p class="text-left" style="margin:12px 0 8px">All custom categories:</p>
        <mat-chip-list #chipList aria-label="All custom categories">
            <mat-chip *ngFor="let category of customCategories">
                {{category.btnText}}
            </mat-chip>
        </mat-chip-list>
        <!-- <ig-button [isAsync]="true" size="md" (trigger)="aiGenerateCategories($event)">Generate Categories</ig-button> -->
    </div>

    <div class="edit-wrap">
        <ig-list>
            <div header>
                <ig-list-column-header>
                    <div class="flex">
                        <p class="half-width text-left">Event Name</p>
                        <p class="half-width">Category</p>
                    </div>
                </ig-list-column-header>
            </div>
            <div body class="overflow-auto">
                <ig-list-item *ngFor="let event of events">
                    <div class="flex" style="min-width: 100%">
                        <div class="half-width text-left">{{event.name}}</div>
                        <div class="half-width flex justify-center items-center">
                            <span *ngIf="!event.categories.length" class="flex">
                                --
                                <mat-icon class="add-category" [matMenuTriggerFor]="actionMenu"
                                    matTooltip="Add category">add</mat-icon>

                                <mat-menu #actionMenu="matMenu">
                                    <button mat-menu-item *ngFor="let defaultCategory of customCategories"
                                        (click)="addCategory(event, defaultCategory)">
                                        {{defaultCategory.btnText}}
                                    </button>
                                </mat-menu>
                            </span>
                            <ng-container *ngIf="event.categories.length">
                                <mat-chip-list #chipList aria-label="AI suggested categories">
                                    <mat-chip *ngFor="let category of event.categories" [selectable]="true"
                                        [removable]="true" (removed)="removeCategory(event, category)">
                                        {{category.name}}
                                        <mat-icon matChipRemove matTooltip="remove">cancel</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                                <mat-icon class="add-category" [matMenuTriggerFor]="actionMenu"
                                    matTooltip="Add category">add</mat-icon>

                                <mat-menu #actionMenu="matMenu">
                                    <button mat-menu-item *ngFor="let defaultCategory of customCategories"
                                        (click)="addCategory(event, defaultCategory)">
                                        {{defaultCategory.btnText}}
                                    </button>
                                </mat-menu>
                            </ng-container>
                        </div>
                    </div>

                    <!-- <ig-row-action-buttons>

                        <mat-icon matTooltip="Get JSON feed API key for this account" (click)="getAPIKey(account)">
                            attach_money
                        </mat-icon>

                    </ig-row-action-buttons> -->
                </ig-list-item>
            </div>
        </ig-list>


    </div>

    <div class="action-btns">
        <ig-button *ngIf="!isClassified" class="btn-primary" #confirmButton color="primary" size="md" [isAsync]="true"
            (trigger)="confirm($event)">
            AI Classification
        </ig-button>
        <ig-button *ngIf="isClassified" class="btn-primary" #confirmButton color="primary" size="md" [isAsync]="true"
            (trigger)="save($event)">
            Save
        </ig-button>
        <div class="cancel-btn" *ngIf="!isClassifying" (click)="close()">
            Cancel
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/ai.event.classification.modal/ai.event.classification.modal.component.html